export const guestFields = [
    {
        field_name: 'First Name',
        field_key: 'fName',
        type: 'string',
        required: true,
    },
    {
        field_name: 'Last Name',
        field_key: 'lName',
        type: 'string',
        required: true,
    },
    {
        field_name: 'Email',
        field_key: 'email',
        type: 'email',
        required: true,
    },
    {
        field_name: 'Mobile Number',
        field_key: 'phone',
        type: 'string',
        required: true,
    },
];

export const customerLoginFields = [
    {
        field_name: 'Email',
        field_key: 'username',
        type: 'email',
        required: true,
    },
    {
        field_name: 'Password',
        field_key: 'password',
        type: 'string',
        required: true,
    },
];

export const loginFields = guestFields;